export default __webpack_public_path__ + "static/media/lady-sofi.b5154fc9.svg";